import apiNtzTemplate from '@/api/ntz-template'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createNtzTemplateStart: '[create ntz template] Create ntz template start',
  createNtzTemplateSuccess:
    '[create ntz  template] Create ntz template success',
  createNtzTemplateFailure:
    '[create ntz  template] Create ntz template failure',
}

export const actionTypes = {
  createNtzTemplate: '[create ntz template] Create ntz template',
}

const mutations = {
  [mutationTypes.createNtzTemplateStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createNtzTemplateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createNtzTemplateFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createNtzTemplate](context, {template}) {
    context.commit(mutationTypes.createNtzTemplateStart)
    return new Promise((resolve) => {
      apiNtzTemplate
        .createNtzTemplate(template)
        .then((response) => {
          context.commit(mutationTypes.createNtzTemplateSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createNtzTemplateFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
